import React from 'react';

export const CategoriesIcon = ({
  width = '25',
  height = '24',
  stroke = '#5C6370',
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M1.5 4.5C1.5 1.87479 1.52811 1 5 1C8.47189 1 8.5 1.87479 8.5 4.5C8.5 7.12521 8.51107 8 5 8C1.48893 8 1.5 7.12521 1.5 4.5Z" stroke="#5C6370" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M12.5 4.5C12.5 1.87479 12.5281 1 16 1C19.4719 1 19.5 1.87479 19.5 4.5C19.5 7.12521 19.5111 8 16 8C12.4889 8 12.5 7.12521 12.5 4.5Z" stroke="#5C6370" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M1.5 15.5C1.5 12.8748 1.52811 12 5 12C8.47189 12 8.5 12.8748 8.5 15.5C8.5 18.1252 8.51107 19 5 19C1.48893 19 1.5 18.1252 1.5 15.5Z" stroke="#5C6370" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M12.5 15.5C12.5 12.8748 12.5281 12 16 12C19.4719 12 19.5 12.8748 19.5 15.5C19.5 18.1252 19.5111 19 16 19C12.4889 19 12.5 18.1252 12.5 15.5Z" stroke="#5C6370" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
